// Central configuration for the application
// This ensures all components use the same configuration source

// Runtime config takes precedence over build-time config
const getConfig = () => {
  const runtimeConfig = (window as any)._env_ || {};

  return {
    API_URL: runtimeConfig.REACT_APP_API_URL ||
             process.env.REACT_APP_API_URL ||
             'http://localhost:8000/api',

    LIVEKIT_URL: runtimeConfig.REACT_APP_LIVEKIT_URL ||
                 process.env.REACT_APP_LIVEKIT_URL ||
                 'wss://good-outcomes-5wnz49fs.livekit.cloud',

    ENVIRONMENT: runtimeConfig.REACT_APP_ENVIRONMENT ||
                 process.env.REACT_APP_ENVIRONMENT ||
                 'development',

    // HyperDX/ClickStack Observability
    HYPERDX_API_KEY: runtimeConfig.REACT_APP_HYPERDX_API_KEY ||
                     process.env.REACT_APP_HYPERDX_API_KEY ||
                     '',

    HYPERDX_SERVICE: runtimeConfig.REACT_APP_HYPERDX_SERVICE ||
                     process.env.REACT_APP_HYPERDX_SERVICE ||
                     'good-outcomes-web',

    // ClickStack OTLP endpoint URL (required for self-hosted)
    HYPERDX_URL: runtimeConfig.REACT_APP_HYPERDX_URL ||
                 process.env.REACT_APP_HYPERDX_URL ||
                 ''
  };
};

// Export a singleton config object
export const config = getConfig();

// For debugging
if (config.ENVIRONMENT === 'development') {
  console.log('App configuration:', config);
}